import { ConfigFilterAtomValues } from '@/types/userConfigs';
import { DEFAULT_MIN_MINUTES } from '../filters/ranges';
import { gameTypeOptions } from '../gameMetrics';
import { GAME_RANGE_OPTIONS, PERIOD_RANGES } from '../gameRange';

export const filterAtomDefaults: ConfigFilterAtomValues = {
  gameType: gameTypeOptions[0],
  periodRange: PERIOD_RANGES.allGames,
  gameRange: GAME_RANGE_OPTIONS.period,
  startDate: '',
  endDate: '',
  deselectedGameIds: [],
  // These needs to be null so that we revert to the default season/competition for the page
  // when clicking reset
  competitionIds: null,
  seasonIds: null,
  playerIds: [],
  teamIds: [],
  positions: [],
  eventNames: [],
  outcomes: [],
  bodyParts: [],
  playPatterns: [],
  pitchStartZones: [],
  pitchEndZones: [],

  minAge: undefined,
  maxAge: undefined,
  minHeight: undefined,
  maxHeight: undefined,
  minObv: undefined,
  maxObv: undefined,
  minMinutes: DEFAULT_MIN_MINUTES,
  maxMinutes: undefined,
  preferredFoot: [],
  nationality: [],
  metricDistributions: [],
  minXg: undefined,
  maxXg: undefined,
  eventFilterGroups: [],

  matchPeriods: [],
  eventsPerspective: 'for',
  minMatchMinute: undefined,
  maxMatchMinute: undefined,
};

/**
 * Sometimes the setting we want to consider default in the persisted config
 * is different to the actual atom default. seasonId is an example of this - the
 * atom default is null (which means it selects some default seasons relevant to
 * the page), but when reading the config in we want to consider no selected seasons
 * to be the default (as you're not filtering at all by season)
 */
export const filterAtomClearDefaults: ConfigFilterAtomValues = {
  ...filterAtomDefaults,
  seasonIds: [],
  competitionIds: [],
};
